// extracted by mini-css-extract-plugin
export var logo = "_l0-2";
export var logoWrapper = "_l0-1";
export var strip = "_l0-0";